import { Outlet, createFileRoute } from "@tanstack/react-router";

import { ConsoleShell } from "../features/console";

/** The console shell. Every console route renders inside it. */
export const Route = createFileRoute("/console")({
  component: Console,
});

function Console() {
  return (
    <ConsoleShell>
      <Outlet />
    </ConsoleShell>
  );
}
